import "./style.css"
import React, {useState, useEffect, useMemo} from "react";
import {useSetRecoilState} from "recoil";
import useWindowDimensions from "../../../helpers/hooks/windowDemensions";
import {uploadPromptState} from "../../../Recoil/Atoms";
import {getDiscountConfig} from "../../../api/discountConfigService";

const BASE_PRICE_PER_FRAME = 49; // ILS per frame

const UploadPrompt = ({show}) => {
  const setPrompt = useSetRecoilState(uploadPromptState);
  const [isClicked, setIsClicked] = useState(false);
  const {width} = useWindowDimensions();
  const [discountConfig, setDiscountConfig] = useState(null);

  useEffect(() => {
    const loadConfig = async () => {
      try {
        const config = await getDiscountConfig();
        setDiscountConfig(config);
      } catch (error) {
        console.error('Error loading discount config:', error);
      }
    };
    loadConfig();
  }, []);

  // Calculate prices based on the featured tier
  const uploadPromptData = useMemo(() => {
    if (!discountConfig || !discountConfig.promotionName) {
      return null;
    }

    const featuredTierCount = discountConfig.uploadPromptTier || 12;
    const tier = discountConfig.tiers?.find(t => t.imageCount === featuredTierCount)
      || discountConfig.tiers?.[discountConfig.tiers.length - 1];

    if (!tier) {
      return null;
    }

    const original = tier.imageCount * BASE_PRICE_PER_FRAME;
    const discounted = Math.round(original * (1 - tier.discount / 100));
    const promoName = discountConfig.promotionName;

    return {
      originalPrice: original,
      discountedPrice: discounted,
      promotionText: `מבצעי ${promoName} - ${tier.discount}% פחות בקניית ${tier.imageCount} בלנדס`
    };
  }, [discountConfig]);

  const handleOnClose = () => {
    setIsClicked(true);
    setTimeout(()=>{
      setPrompt(false);
    }, 1500)
  }

  // Don't render until config is loaded
  if (!uploadPromptData) {
    return null;
  }

  const { originalPrice, discountedPrice, promotionText } = uploadPromptData;

  return (
    <>
      <div className={`upload-prompt ${show ? "show" : ""} ${isClicked ? "clicked" : ""}`}>
        <div className={`upload-prompt-content ${isClicked ? "clicked" : ""}`}>
          <img src="/assets/images/frame-upload-prompt.svg" style={{width: "37px", height: "37px"}} alt="" />
          <div className={"upload-prompt-content-text"}>
            <p className={"upload-prompt-content-first-text"}>
              איזה כיף, באתם בזמן
            </p>
            <div className={"upload-prompt-content-second-text"}>
              {width < 767 ? (
                <>
                  <div className={"upload-prompt-content-second-text-mobile"}>
                    <p>
                      ₪{discountedPrice}
                    </p>
                    <p>
                      ₪{originalPrice}
                    </p>
                  </div>
                </>
              ) : (
                <>
                  <p>
                    ₪{discountedPrice}
                  </p>
                  <p>
                    ₪{originalPrice}
                  </p>
                </>
              )}
              <p>
                {promotionText}
              </p>
            </div>
          </div>
          <div className={"upload-prompt-content-button"}>
            <button
              onClick={() => {handleOnClose()}}
            >
              <p>הבנתי, תודה</p>
            </button>
          </div>
        </div>
      </div>
    </>
  )
}

export default UploadPrompt;